<div [class.isPrinting]="printService.isPrinting">
  <ngx-spinner bdColor="rgba(0,0,0,0)"
               size="medium"
               color="#000000"
               type="ball-spin-clockwise">
  </ngx-spinner>

  <div class="row" *ngIf="BillsList">
    <div class="col-md-12 padding-right-0px padding-left-0px margin-top-10">
      <div class="card">
        <div class="card-header wh-header font-size-16px font-weight-normal border-bottom1px-solidgray border-left15px-solidgray padding-top-6px padding-left-15px">
          <div class="row">
            <div class="col-md-3">
              <label class="margin-bottom-0px color-backarrow font-weight-bold font-size-25px">View Bills</label>
            </div>
            <div class="col-md-7 text-align-right padding-left-0px padding-right-0px">
              <!--<button type="submit" class="btn btn-secondary actions-btn-prime float-right font-size-13px margin-right-auto">Convert To Ivf&#64;Home</button>-->

              <button *canUserAccess="['HL_BL_5']"
                      type="button" (click)="AddAdv()" class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-5px float-right">
                <i class="fa fa-plus color-Assign margin-right-3px"></i>Add Adv
              </button>
              <button *canUserAccess="['HL_BL_29']"
                      type="button" (click)="Addbill()" class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-5px float-right">
                <i class="fa fa-plus color-Assign margin-right-3px"></i>Add Bill
              </button>
              <button *canUserAccess="['HL_BL_30']"
                      type="button" (click)="Addbill_withSvcProvider()" class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-5px float-right">
                <i class="fa fa-plus color-red margin-right-3px"></i>Add Bill
              </button>
            </div>
          </div>
        </div>
        <div class="card-body padding-all-0px">
          <div class="row margin-left-10px margin-top-5px">

            <div class="col-md-2 mistable-data2">
              <div class="row margin-left-0px font-size-12px font-weight-bold">
                Total Amount
              </div>
              <div class="row margin-left-0px misdatafont" *ngIf="TotalAmount !== undefined && TotalAmount !== null">
                {{TotalAmount | number:'1.0-0'}}
              </div>
            </div>
            <div class="col-md-2 mistable-data2">
              <div class="row margin-left-0px font-size-12px font-weight-bold">
                Total Paid
              </div>
              <div class="row margin-left-0px misdatafont" *ngIf="TotalPaid !== undefined && TotalPaid !== null">
                {{TotalPaid | number:'1.0-0'}}
              </div>
            </div>
            <div class="col-md-2 mistable-data2">
              <div class="row margin-left-0px font-size-12px font-weight-bold">
                Total Discount
              </div>
              <div class="row margin-left-0px misdatafont" *ngIf="TotalDiscount !== undefined && TotalDiscount !== null">
                {{TotalDiscount | number:'1.0-0'}}
              </div>
            </div>
            <div class="col-md-2 mistable-data2">
              <div class="row margin-left-0px font-size-12px font-weight-bold">
                Total Due
              </div>
              <div class="row margin-left-0px misdatafont" *ngIf="TotalDue !== undefined && TotalDue !== null">
                {{TotalDue | number:'1.0-0'}}
              </div>
            </div>
            <div class="col-md-2 mistable-data2">
              <div class="row margin-left-0px font-size-12px font-weight-bold">
                Total Advance
              </div>
              <div class="row margin-left-0px misdatafont" *ngIf="TotalAdvance !== undefined && TotalAdvance !== null">
                {{TotalAdvance | number:'1.0-0'}}
              </div>
            </div>
          </div>

          <div class="row margin-left-10px">
            <div class="col-md-12">

              <ul class="nav nav-tabs nav-tab-service2" id="tabContent">
                <li class="active margin-right-15px"><a class="nav-itemerp active" href="#opbills" data-toggle="tab">OP Bills</a></li>
                <li class="margin-right-15px"><a class="nav-itemerp" href="#rxbills" data-toggle="tab">RX Bills</a></li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane active" id="opbills">

                  <div class="table-component">
                    <div class="table-responsive overflow-x">


                      <table class="table table-striped"
                             cols="auto,2*,*,*,*,*,*,*">

                        <thead class="">
                          <tr>

                            <th hidden class="min-width-24px">
                              #
                            </th>


                            <th class="">
                              Bill Date
                            </th>
                            <th class="text-align-center padding-left-0px">
                              Bill No
                            </th>
                            <th>Bill Type</th>
                            <th>Branch</th>
                            <th class="text-align-right">
                              Total Amount
                            </th>
                            <th class="text-align-right">
                              Disc %
                            </th>
                            <th class="text-align-center">
                              Paid
                            </th>
                            <th>Due</th>

                            <th class="padding-left-0px padding-right-0px">
                              Status
                            </th>






                          </tr>
                        </thead>

                        <tbody class="table-body">
                          <tr *ngFor="let l of BillCodesOP">
                            <td class="td-padding-tb"><a (click)="Selectedpatient(l)" class="nav-link-hand"> {{ (l.BillCreatedDate || l.BillDate) | date:'MMM-dd-yyyy'}}</a></td>
                            <td class="text-align-center td-padding-tb padding-right-0px padding-left-8px"><a (click)="Selectedpatient(l)" class="nav-link-hand">{{l.FormattedCode || l.BillNo}}</a></td>
                            <td class="td-padding-tb">{{l.BillType}}</td>
                            <td class="td-padding-tb ">{{l.BranchName}}</td>
                            <td class="td-padding-tb text-align-right padding-left-0px padding-right-15px">{{(l.TotalAmount || l.ItemTotal || 0) | number:'1.0-0' |removeComma}}</td>
                            <td class="td-padding-tb text-align-right">{{(l.Discount || 0) | number:'1.0-0' |removeComma}}</td>
                            <td class="td-padding-tb text-align-center">{{(l.PaidTotal || l.Paid || 0) | number:'1.0-0' |removeComma}}</td>
                            <td class="td-padding-tb text-align-center">{{(l.Balance || 0) | number:'1.0-0' |removeComma}}</td>
                            <td class="td-padding-tb">
                              <a data-toggle="tooltip" data-placement="bottom" title="Fully Paid" *ngIf="l.BillStatus=='FP'">
                                <i class="fas fa-circle color-green nav-link-hand font-size-14"></i>
                              </a>
                              <a data-toggle="tooltip" data-placement="bottom" title="Partially Paid" *ngIf="l.BillStatus=='PP'">
                                <i class="fas fa-circle color-Assign nav-link-hand font-size-14"></i>
                              </a>
                              <a data-toggle="tooltip" data-placement="bottom" title="Not Paid" *ngIf="l.BillStatus=='NP'">
                                <i class="fas fa-circle color-gray nav-link-hand font-size-14"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>

                      </table>
                    </div>
                  </div>

                </div>

                <div class="tab-pane" id="rxbills">
                  <!--<div class="row margin-left-0px margin-top-10" *ngFor="let l of BillCodesRX"></div>-->
                  <div class="table-component">
                    <div class="table-responsive overflow-x">


                      <table class="table table-striped"
                             cols="auto,2*,*,*,*,*,*,*">

                        <thead class="">
                          <tr>

                            <th hidden class="min-width-24px">
                              #
                            </th>


                            <th class="">
                              Bill Date
                            </th>
                            <th class="text-align-center padding-left-0px">
                              Bill No
                            </th>
                            <th>Bill Type</th>
                            <th>Branch</th>
                            <th class="text-align-right">
                              Total Amount
                            </th>
                            <th class="text-align-right">
                              Disc %
                            </th>
                            <th class="text-align-center">
                              Paid
                            </th>
                            <th>Due</th>

                            <th class="padding-left-0px padding-right-0px">
                              Status
                            </th>

                          </tr>
                        </thead>

                        <tbody class="table-body">
                          <tr *ngFor="let l of BillCodesRX">
                            <td class="td-padding-tb"><a (click)="Selectedpatient(l)" class="nav-link-hand"> {{ (l.BillCreatedDate || l.BillDate) | date:'MMM-dd-yyyy'}}</a></td>
                            <td class="text-align-center td-padding-tb padding-right-0px padding-left-8px"><a (click)="Selectedpatient(l)" class="nav-link-hand">{{l.FormattedCode || l.BillNo}}</a></td>
                            <td class="td-padding-tb">{{l.BillType}}</td>
                            <td class="td-padding-tb ">{{l.BranchName}}</td>
                            <td class="td-padding-tb text-align-right padding-left-0px padding-right-15px">{{(l.TotalAmount || l.ItemTotal || 0) | number:'1.0-0' |removeComma}}</td>
                            <td class="td-padding-tb text-align-right">{{(l.Discount || 0) | number:'1.0-0' |removeComma}}</td>
                            <td class="td-padding-tb text-align-center">{{(l.PaidTotal || l.Paid || 0) | number:'1.0-0' |removeComma}}</td>
                            <td class="td-padding-tb text-align-center">{{(l.Balance || 0) | number:'1.0-0' |removeComma}}</td>
                            <td class="td-padding-tb">
                              <a data-toggle="tooltip" data-placement="bottom" title="Fully Paid" *ngIf="l.BillStatus=='FP'">
                                <i class="fas fa-circle color-green nav-link-hand font-size-14"></i>
                              </a>
                              <a data-toggle="tooltip" data-placement="bottom" title="Partially Paid" *ngIf="l.BillStatus=='PP'">
                                <i class="fas fa-circle color-Assign nav-link-hand font-size-14"></i>
                              </a>
                              <a data-toggle="tooltip" data-placement="bottom" title="Not Paid" *ngIf="l.BillStatus=='NP'">
                                <i class="fas fa-circle color-gray nav-link-hand font-size-14"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>

                      </table>
                    </div>
                  </div>


                </div>
              </div>


              <!--<div class="table-component" hidden>
        <div class="table-responsive overflow-x">


          <table class="table table-striped"
                 cols="auto,2*,*,*,*,*,*,*">

            <thead class="">
              <tr>

                <th class="min-width-24px">
                  #
                </th>


                <th class="">
                  Bill Date
                </th>
                <th class="text-align-center padding-left-0px">
                  Bill No
                </th>
                <th>Bill Type</th>
                <th>Branch</th>
                <th class="text-align-right">
                  Total Amount
                </th>
                <th class="text-align-right">
                  Disc %
                </th>
                <th class="text-align-center">
                  Paid
                </th>
                <th>Due</th>

                <th class="padding-left-0px padding-right-0px">
                  Status
                </th>






              </tr>
            </thead>

            <tbody class="table-body">
              <tr *ngFor="let l of CurrentBillDetailsInfoController ; let RowIndex = index ">


                <td class="td-padding-tb">

                  {{RowIndex+1}}

                </td>
                <td class=" td-padding-tb"><a (click)="Selectedpatient(l)" class="nav-link-hand"> {{l.BillCreatedDate | date:'MMM-dd-yyyy'}}</a></td>

                <td class="text-align-center td-padding-tb padding-right-0px padding-left-8px"><a (click)="Selectedpatient(l)" class="nav-link-hand">{{l.FormattedCode}}</a></td>
                <td class="td-padding-tb">{{l.BillType}}</td>
                <td class="td-padding-tb ">{{l.BranchName}}</td>
                <td class="td-padding-tb text-align-right padding-left-0px padding-right-15px">{{l.TotalAmount | number:'1.0-0' |removeComma}}</td>
                <td class="td-padding-tb text-align-right">{{l.Discount| number:'1.0'}}</td>
                <td class="td-padding-tb text-align-center">{{l.PaidTotal}}</td>
                <td class="td-padding-tb text-align-center">{{l.Balance| number:'1.0'}}</td>
                <td class=" td-padding-tb">

                  <a data-toggle="tooltip" data-placement="bottom" title="Fully Paid" *ngIf="l.BillStatus=='FP'">

                    <i class="fas fa-circle color-green  nav-link-hand font-size-14">
                    </i>
                  </a>
                  <a data-toggle="tooltip" data-placement="bottom" title="Partially Paid" *ngIf="l.BillStatus=='PP'">

                    <i class="fas fa-circle color-Assign  nav-link-hand font-size-14">
                    </i>
                  </a>
                  <a data-toggle="tooltip" data-placement="bottom" title="Not Paid" *ngIf="l.BillStatus=='NP'">

                    <i class="fas fa-circle color-gray  nav-link-hand font-size-14">
                    </i>
                  </a>
                </td>



              </tr>


            </tbody>



          </table>
        </div>
      </div>-->
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
  <div class="row" *ngIf="BillsDetails">
    <div class="col-md-12 padding-left-0px padding-right-0px">
      <div class="row margin-left-0px">
        <div class="col-md-8 padding-right-0px padding-left-0px">




          <div class="card">
            <div class="card-header wh-header border-bottom1px-solidgray padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px font-size-16px color-backarrow">
              <div class="row nav-link-hand margin-right-0px margin-left-0px" id="edit-link">
                <div class="col-md-3 padding-right-0px padding-left-5px margin-top-3px" *ngIf="CurrentX_BillHeaderController">
                  <!--<label class="margin-bottom-0px font-size-16px font-weight-normal padding-left-10px" *ngIf="CurrentX_BillHeaderController">
                    {{CurrentX_BillHeaderController.BillType}} Details

                  </label>-->
                  <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Bills"
                     (click)="BackToBillsList()"><i class="fas fa-angle-double-left font-size-19px"></i></a>  {{CurrentX_BillHeaderController.BillType}} Details

                </div>
                <!--<div class="col-md-7 text-align-right">

                  <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Total</label>:<label class="font-weight-normal font-size-12px margin-bottom-0px ">5000</label>,
                  <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Paid</label>:<label class="font-weight-normal font-size-12px margin-bottom-0px "></label>,
                  <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Due</label>:<label class="font-weight-normal font-size-12px margin-bottom-0px ">0</label>
                </div>-->
                <div class="col-md-9  padding-right-3px">
                  <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
                  <div class="row float-right" *ngIf="CurrentX_BillHeaderController">

                    <!--<div class="col-md-1 margin-top-3px padding-right-10px">
                      <button type="button" (click)="opbill()" class="button-service-save font-size-16px color-secondary nav-link-hand margin-left-3px" title="Save"><i class="fas fa-pencil-alt"></i></button>


                    </div>-->


                    <div class="col-md-12 margin-top-3px padding-left-0px padding-right-0px text-align-right" *ngIf="CurrentX_BillHeaderController">
                      <button type="button" (click)="ConvertToIah()" class="btn actions-btn-prime  font-size-13px margin-right-5px" hidden>Convert To Ivf&#64;Home</button>
                      <!--<button type="button" (click)="billedit()" class="button-service-save font-size-16px color-secondary nav-link-hand margin-left-3px" title="Save" *ngIf="CurrentX_BillHeaderController.BillStatus=='NotPaid'"><i class="fas fa-pencil-alt"></i></button>-->
                      <div class="display-inline" *canUserAccess="['HL_BL_14']">
                        <button type="submit"
                                *ngIf="CurrentX_BillHeaderController.BillType=='RXBILL' && CurrentX_BillHeaderController.BillStatus=='NP'"
                                class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-15px"
                                (click)="billeditRX()">
                          <i class="fas fa-pencil-alt nav-link-hand font-size-12px margin-top-5px"></i> Edit
                        </button>
                      </div>
                      <div class="display-inline" *canUserAccess="['HL_BL_9']">
                        <button type="submit"
                                *ngIf="CurrentX_BillHeaderController.BillType=='OPBILL' && CurrentX_BillHeaderController.BillStatus=='NP' || CurrentX_BillHeaderController.BillStatus=='PP'"
                                class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-15px"
                                (click)="billeditOP()">
                          <i class="fas fa-pencil-alt nav-link-hand font-size-12px margin-top-5px"></i> Edit
                        </button>
                      </div>
                      <div class="display-inline" *canUserAccess="['HL_BL_11']">
                        <button type="submit"
                                class="btn btn-profile actions-btn-prime-profile2 nav-link-hand font-size-13px margin-right-15px"
                                (click)="opbill()" *ngIf="CurrentX_BillHeaderController.BillType=='OPBILL'">
                          <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Print
                        </button>
                      </div>
                      <div class="display-inline" *canUserAccess="['HL_BL_32']">
                        <button type="submit"
                                class="btn btn-profile actions-btn-prime-profile2 nav-link-hand font-size-13px margin-right-15px"
                                (click)="opbillSvc_Provider()" *ngIf="CurrentX_BillHeaderController.BillType=='OPBILL'">
                          <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Print
                        </button>
                      </div>
                      <div class="display-inline">
                        <button type="submit"
                                class="btn btn-profile actions-btn-prime-profile2 nav-link-hand font-size-13px margin-right-15px"
                                (click)="opadvbill()" *ngIf="CurrentX_BillHeaderController.BillType=='OPADVC'">
                          <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Print
                        </button>
                      </div>
                      <div class="display-inline">
                        <button type="submit"
                                class="btn btn-profile actions-btn-prime-profile2 nav-link-hand font-size-13px margin-right-15px"
                                (click)="ipadvbill()" *ngIf="CurrentX_BillHeaderController.BillType=='IPADVC'">
                          <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Print
                        </button>
                      </div>
                      <div class="display-inline" *canUserAccess="['HL_BL_16']">
                        <button type="submit"
                                class="btn btn-profile actions-btn-prime-profile2 nav-link-hand font-size-13px margin-right-15px"
                                (click)="rxbill()" *ngIf="CurrentX_BillHeaderController.BillType=='RXBILL'">
                          <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Print
                        </button>
                      </div>
                      <!--<a class="nav-link-hand education-navlink data-color-new" (click)="opbill()" title="print" *ngIf="CurrentX_BillHeaderController.BillType=='OPBILL'">
    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
  </a>
  <a class="nav-link-hand education-navlink data-color-new" (click)="opadvbill()" title="print" *ngIf="CurrentX_BillHeaderController.BillType=='OPADVC'">
    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
  </a>
  <a class="nav-link-hand education-navlink data-color-new" (click)="ipadvbill()" title="print" *ngIf="CurrentX_BillHeaderController.BillType=='IPADVC'">
    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
  </a>
  <a class="nav-link-hand education-navlink data-color-new" (click)="rxbill()" title="print" *ngIf="CurrentX_BillHeaderController.BillType=='RXBILL'">
    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
  </a>-->
                    </div>

                    </div>




                </div>

              </div>
            </div>
            <div class=" padding-lrt " data-ps-id="dfsfsde">
              <div class="card-body">
                <div id="items">
                  <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                    <div class="accordion" id="accordionExample">
                      <div class="card margin-bottom-5px">
                        <div class="card-header font-weight-normal wh-header3 border-all-0px border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                          <div class="row">
                            <div class="col-md-4">
                              <h5 class="mb-0 height-24px">
                                <button class="btn background-lineheight color-head-blue padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                  Services
                                </button>
                              </h5>
                            </div>

                          </div>


                        </div>

                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                          <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="table-component">
                                  <div class="table-responsive overflow-x">


                                    <table class="table table-striped"
                                           cols="auto,2*,*,*,*,*,*,*">

                                      <thead class="">
                                        <tr>

                                          <th class="min-width-24px padding-bottom-4px padding-top-4px">
                                            #
                                          </th>


                                          <th class="padding-top-4px padding-bottom-4px">
                                            Service Description
                                          </th>
                                          <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px">
                                            QTY
                                          </th>
                                          <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px">
                                            Unit Price
                                          </th>
                                          <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px">
                                            Item Total
                                          </th>




                                          <th class="text-align-right padding-right-0px padding-top-4px padding-bottom-4px">
                                            Disc %
                                          </th>

                                          <th class="text-align-right padding-top-4px padding-bottom-4px">
                                            Net
                                          </th>
                                          <th class="text-align-right padding-top-4px padding-bottom-4px">
                                            
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody class="table-body">
                                        <tr *ngFor="let l of CurrentX_BillItemsController;let RowIndex = index">
                                          <td class="td-padding-tb">
                                            {{RowIndex+1}}
                                          </td>
                                          <td class=" td-padding-tb">{{l.ItemDescription || l.itemDescription || l.ServiceDescription || l.serviceDescription || l.ServiceName || l.serviceName || l.ItemName || l.itemName || l.Description || l.description}}</td>
                                          <td class="text-align-center td-padding-tb padding-right-0px">{{l.Quantity || l.Qty || 1}}</td>
                                          <td class="text-align-right td-padding-tb  padding-right-14px">{{(l.UnitPrice || l.Rate || l.Price || 0) | number:'1.0-2' |removeComma}}</td>
                                          <td class="td-padding-tb text-align-right ">{{(l.ItemTotal || l.TotalAmount || l.Amount || ((l.Quantity || 1) * (l.UnitPrice || 0)) || 0) | number:'1.0-2' |removeComma}}</td>
                                          <td class="td-padding-tb text-align-right  padding-left-0px">{{(l.Discount || l.DiscountPercentage || 0) | number:'1.0-2' |removeComma}}</td>
                                          <td class="td-padding-tb text-align-right  padding-left-0px">{{(l.Net ? l.Net : (l.ItemTotal ? (l.ItemTotal - (l.Discount || 0)) : ((l.Quantity || 1) * (l.UnitPrice || 0)))) | number:'1.0-2' |removeComma}}</td>
                                          <td class="td-padding-tb text-align-right  padding-left-0px">
                                            <a  *canUserAccess="['HL_BL_22']"
                                               (click)="SelectedItem(l)"
                                               class="nav-link-hand font-size-16px color-Rejected" title="Remove">
                                            <i class="far fa-trash-alt nav-link-hand"></i></a>
                                          </td>
                                        </tr>
                                      </tbody>



                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>



                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div id="Receipts">
                  <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                    <div class="accordion" id="accordionExample">
                      <div class="card margin-bottom-5px">
                        <div class="card-header font-weight-normal wh-header3 border-all-0px border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingRe">
                          <div class="row">
                            <div class="col-md-4">
                              <h5 class="mb-0 height-24px">
                                <button class="btn background-lineheight color-head-blue padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseRe" aria-expanded="true" aria-controls="collapseRe">
                                  Receipts
                                </button>
                              </h5>
                            </div>

                          </div>


                        </div>

                        <div id="collapseRe" class="collapse show" aria-labelledby="headingRe" data-parent="#accordionExample">
                          <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="table-component">
                                  <div class="table-responsive overflow-x">


                                    <table class="table table-striped"
                                           cols="auto,2*,*,*,*,*,*,*">

                                      <thead class="">
                                        <tr>

                                          <th class="min-width-24px padding-top-4px padding-bottom-4px">
                                            #
                                          </th>


                                          <th class="padding-top-4px padding-bottom-4px">
                                            Date
                                          </th>
                                          <th class="text-align-left padding-left-0px padding-top-4px padding-bottom-4px">
                                            Receipt No
                                          </th>
                                          <th class="text-align-left padding-top-4px padding-bottom-4px">
                                            Payment Mode
                                          </th>
                                          <th class="text-align-right padding-top-4px padding-bottom-4px">
                                            Amount
                                          </th>

                                          <th class="text-align-left padding-top-4px padding-bottom-4px">
                                            Details
                                          </th>








                                        </tr>
                                      </thead>

                                      <tbody class="table-body">
                                        <tr *ngFor="let l of CurrentX_BillReceiptsController;let RowIndex = index">


                                          <td class="td-padding-tb">

                                            {{RowIndex+1}}
                                          </td>
                                          <td class=" td-padding-tb">{{l.ReceiptDate | date:'MMM-dd-yyyy'}}</td>

                                          <td class="text-align-left padding-left-0px td-padding-tb">{{l.FormattedCode}}</td>
                                          <td class="text-align-left td-padding-tb ">{{l.PaymentInstrument}}</td>
                                          <td class="text-align-right td-padding-tb">{{l.ReceivedAmount | number:'1.0' |removeComma}}</td>

                                          <td class="td-padding-tb text-align-center">{{l.Remarks}}</td>




                                        </tr>

                                      </tbody>



                                    </table>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>


              </div>
            </div>
          </div>



        </div>
        <div class="col-md-4 padding-left-0px padding-right-0px border-left-7px">
          <div class="">
            <div class="card">
              <div class="card-header border-bottom1px-solidgray border-left15px-solidgray font-size-16px border-radius-5px wh-header padding-top-3px padding-bottom-3px padding-right-0px padding-left-9px">
                <label class="margin-bottom-0px color-head-blue">Bill Information</label>
              </div>
              <div class="card-body padding-top-0px padding-left-0px padding-right-0px margin-left-0px padding-bottom-0px">
                <div class=" margin-top-5px border-bottom-8px-document">
                  <div class="row font-weight-700 margin-left-0px margin-right-0px">
                    <!--<div class="col-md-4 text-align-right padding-right-7px">
                      <label class="font-size-12px font-weight-normal margin-bottom-0px white-space-pre">Patient Name</label>
                    </div>:-->
                    <div class="col-md-9 font-size-12px font-weight-normal padding-right-0px" *ngIf="PatientName">
                      <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px color-Assign">{{PatientName}}</label>

                    </div>
                  </div>
                  <div class="row font-weight-700">
                    <div class="col-md-4 text-align-right">
                      <label class="font-size-12px font-weight-normal margin-bottom-0px">Bill Date  </label>
                    </div>:
                    <div class="col-md-7 font-size-12px font-weight-normal" *ngIf="CurrentX_BillHeaderController">

                      <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{CurrentX_BillHeaderController.BillCreatedDate | date:'MMM-dd-yyyy'}} {{CurrentX_BillHeaderController.BillCreatedDate| date: 'hh:mm a'}}</label>
                    </div>
                  </div>

                  <div class="row font-weight-700">
                    <div class="col-md-4 text-align-right">
                      <label class="font-size-12px font-weight-normal margin-bottom-0px">Branch  </label>
                    </div>:
                    <div class="col-md-7 font-size-12px font-weight-normal" *ngIf="CurrentX_BillHeaderController">

                      <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{CurrentX_BillHeaderController.BranchName}}</label>
                    </div>
                  </div>
                  <div class="row font-weight-700">
                    <div class="col-md-4 text-align-right">
                      <label class="font-size-12px font-weight-normal margin-bottom-0px">Bill By</label>
                    </div>:
                    <div class="col-md-5 font-size-12px margin-top-3px font-weight-normal" *ngIf="CurrentX_BillHeaderController">
                      <label class="font-size-14 font-weight-normal margin-bottom-0px">{{CurrentX_BillHeaderController.PayeeName || CurrentX_BillHeaderController.UserName || CurrentX_BillHeaderController.CreatedBy || CurrentX_BillHeaderController.DoctorName || '-'}}</label>
                    </div>
                  </div>
                  <div class="row font-weight-700">
                    <div class="col-md-4 text-align-right">
                      <label class="font-size-12px font-weight-normal margin-bottom-0px"> Total Bill </label>
                    </div>:
                    <div class="col-md-5 font-size-12px font-weight-normal" *ngIf="CurrentX_BillHeaderController">
                      <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{(CurrentX_BillHeaderController.TotalAmount || CurrentX_BillHeaderController.ItemTotal || CurrentX_BillHeaderController.BillAmount || 0) | number:'1.0' |removeComma}}</label>
                    </div>
                  </div>
                  <div class="row font-weight-700">
                    <div class="col-md-4 text-align-right">
                      <label class="font-size-12px font-weight-normal margin-bottom-0px"> Discount </label>
                    </div>:
                    <div class="col-md-5 font-size-12px font-weight-normal" *ngIf="CurrentX_BillHeaderController">
                      <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{(CurrentX_BillHeaderController.Discount || 0) | number:'1.0' |removeComma}}</label>
                    </div>
                  </div>
                  <div class="row font-weight-700">
                    <div class="col-md-4 text-align-right">
                      <label class="font-size-12px font-weight-normal margin-bottom-0px"> Net </label>
                    </div>:
                    <div class="col-md-5 font-size-12px font-weight-normal" *ngIf="CurrentX_BillHeaderController">
                      <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{(CurrentX_BillHeaderController.Net || CurrentX_BillHeaderController.TotalAmount || 0) | number:'1.0' |removeComma}}</label>
                    </div>
                  </div>
                  <div class="row font-weight-700">
                    <div class="col-md-4 text-align-right">
                      <label class="font-size-12px font-weight-normal margin-bottom-0px"> Paid </label>
                    </div>:
                    <div class="col-md-5 font-size-12px font-weight-normal" *ngIf="CurrentX_BillHeaderController">
                      <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{(CurrentX_BillHeaderController.Paid || CurrentX_BillHeaderController.PaidTotal || 0) | number:'1.0' |removeComma}}</label>
                    </div>
                  </div>
                  <div class="row font-weight-700" *ngIf="CurrentX_BillHeaderController">
                    <div class="col-md-4 text-align-right">
                      <label class="font-size-12px font-weight-normal margin-bottom-0px"> Due </label>
                    </div>:
                    <div class="col-md-5 font-size-12px font-weight-normal">
                      <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{(CurrentX_BillHeaderController.Balance || CurrentX_BillHeaderController.Due || 0) | number:'1.0' |removeComma}}</label>
                    </div>
                  </div>
                </div>

                <div class="accordion" id="accordionExampleSections">
                  <div class="card margin-bottom-5px">
                    <div class="card-header font-weight-normal wh-header border-all-0px border-bottom1px-solidgray border-left15px-solidgray border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingSection">
                      <div class="row">
                        <div class="col-md-5 padding-top-5px">
                          <h5 class="mb-0 height-24px">
                            <button class="btn background-lineheight color-head-blue padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseSection" aria-expanded="true" aria-controls="collapseSection">
                              Billing Sections
                            </button>
                          </h5>
                        </div>

                      </div>


                    </div>

                    <div id="collapseSection" class="collapse show" aria-labelledby="headingSection" data-parent="#accordionExampleSection">
                      <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                        <!--<div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                          <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="header()">Bill Header</a>




                        </div>-->
                        <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                          <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="items()">Services</a>
                          <!--<label> {{p.Title}}</label>-->



                        </div>
                        <div class="row card margin-left-0px margin-right-0px margin-bottom-5px" *ngIf="CurrentX_BillHeaderController?.BillType!=='RXBILL'">
                          <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="Receipts()">Advances</a>
                          <!--<label> {{p.Title}}</label>-->



                        </div>


                        <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                          <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="Receipts()">Receipts</a>
                          <!--<label> {{p.Title}}</label>-->



                        </div>


                      </div>
                    </div>

                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>

<!--<div class="row" *ngIf="Formedit">
  <div class="col-md-8 padding-left-0px">


    <div class="card">

      <div class="card-body padding-all-0px">
        <div *ngIf="FormData" class="margin-top-10">


          <div class="row card margin-left-0px margin-right-0px margin-bottom-5px" *ngFor="let l of FormData;let RowIndex = index">

            <div [id]="'accordion'+RowIndex">
              <div class="card-header wh-header font-size-16px  padding-top-6px padding-bottom-6px card-header-bg border-left-clinical padding-l-8px padding-right-8px font-weight-normal2 font-size-16px" [id]="'heading'+RowIndex">
                <div class="row">
                  <div class="col-md-3">
                    <h5 class="mb-0">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                              aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                        {{l.Title}}

                      </button>

                    </h5>
                  </div>
                  <div class="col-md-9">
                    <button type="submit" class="btn actions-btn-prime float-right">Save</button>
                    <button type="button"
                            (click)="Backtolist()" class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3 float-right margin-right-10px">
                      Cancel
                    </button>
                  </div>
                </div>


              </div>
              <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                   [attr.data-parent]="'#accordion'+RowIndex">
                <div class="card-body padding-bottom-19px padding-right-0px padding-top-0px">

                  <div class="row col-md-12 card" *ngFor="let f of l.Fields">


                    <div class="card-header wh-header font-size-14 padding-l-8px padding-t-6px padding-bottom-0px padding-right-0px" *ngIf="f.isHeader">
                      {{f.Title}}
                    </div>
                    <div class="card-body padding-bottom-0px padding-top-0px margin-left-zero">
                      <div *ngIf="f.isSubHeader">
                        <label class="font-size-14 margin-bottom-0px">{{f.Title}}</label>
                      </div>


                      <div *ngIf="f.isTextField">
                        <div class="row form-group">
                          <div class="col-md-3 padding-right-0px text-align-right">
                            <label class="font-size-12px margin-bottom-0px margin-top-10">{{f.Title}}</label>
                          </div>
                          <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="Value" required maxlength="100" minlength="1">
                          </div>
                        </div>


                      </div>
                      <div *ngIf="f.isSubChild">
                        <div class="row form-group">
                          <div class="col-md-3 text-align-right">
                            <label class="font-size-12px margin-bottom-0px margin-top-10">{{f.Title}}</label>
                          </div>:
                          <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="Value" required maxlength="100" minlength="1">
                          </div>
                        </div>
                      </div>


                      <div *ngIf="f.Remarks">
                        <label class="margin-left-10px margin-bottom-0px">{{f.Remarks}}</label>
                      </div>
                      <div *ngIf="f.HasSeparator">
                        <div class="border-bottom-light"></div>
                      </div>
                    </div>
                  </div>



                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">

  </div>
</div>-->
<!--<div class="row">
  <div class="col-md-12">
    <medicalrecordview [FormattedCode]="FormattedCode" *ngIf="viewhealthrecord"></medicalrecordview>
  </div>

</div>-->
